class NavigationFolding extends Component {
    constructor(el) {
        super(el);
        this.nav = this.$find('[data-folding-nav-items]');
        this.hamburger = document.querySelectorAll('[data-nav-opener]');
        this.addEventListeners();
    }

    setFoldingMenu() {
        const menuHolder = document.querySelector('[data-component="AppNavigation"] .AppNavigation-list');

        this.nav.innerHTML = "";
        if (Array.from(this.hamburger).some(el => getComputedStyle(el).display !== 'none')) { // mobile layout reset
            this.classList.remove('is-visible');
            return;
        }

        // if (menuHolder.firstElementChild && menuHolder.clientHeight > menuHolder.firstElementChild.clientHeight)
        //     this.classList.add('is-visible');

        menuHolder.childNodes.forEach(link => {
            if (link.offsetTop !== menuHolder.firstElementChild.offsetTop)
                this.nav.append(link.cloneNode(true));
        })
    }

    addEventListeners() {
        window.addEventListener('DOMContentLoaded', () => {
            this.setFoldingMenu();
        });
        window.addEventListener('resize', () => {
            this.setFoldingMenu();
        });
    }
}